// extracted by mini-css-extract-plugin
export default {"content":"input_content__r68zL","input":"input_input__ETrTc"};